<template id="Photomaton">
	<div>
		<Modele id="Photomaton"/>
		<div id='img_photomaton'></div>
	</div>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Photomaton',
	data () {
		return {}
	}
}
</script>

<style scoped>
#img_photomaton{
	height:500px;
	background-image:url(../../assets/photomaton2.jpg);
	background-size:cover;
}
</style>


// WEBPACK FOOTER //
// src/components/EtatCivil/Photomaton.vue